import apiEndPointsList from "../constant/apiEndPointsList";
import { baseGet, basePost } from "@/utils/api/base";

const projectService = {
    getAllProject: async () => {
        const response = await baseGet({
            endpoint: apiEndPointsList.project.GET_ALL_PROJECT,
        });
        return response.data;
    },

    getNewPlatformProjectsPublic: async (params) => {
        let queryString = '';
        if (params) {
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    queryParams.append(key, value);
                }
            });
            queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        }
        
        const response = await baseGet({
            endpoint: `${apiEndPointsList.project.NEW_PLATFORM_PUBLIC}${queryString}`,
        });
        return response.data;
    },

    getProjectsByLocation: async (params, options = {}) => {
        let queryString = '';
        if (params) {
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    queryParams.append(key, value);
                }
            });
            queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        }
        
        const response = await baseGet({
            endpoint: `${apiEndPointsList.project.NEW_PLATFORM_LOCATION}${queryString}`,
            signal: options.signal,
        });
        return response.data;
    },

    searchProject: async (keyword) => {
        const response = await basePost({
            endpoint: apiEndPointsList.project.SEARCH_PROJECT,
            body: {
                keyword
            }
        });
        return response.data;
    },

    countViewWebApp: async () => {
        const response = await baseGet({
            endpoint: apiEndPointsList.project.COUNT_VIEW_WEB_APP,
        });
        return response.data;
    },

    getAllFields: async () => {
        const response = await baseGet({
            endpoint: apiEndPointsList.project.GET_ALL_FIELDS,
        });
        return response.data;
    },

    getHotspotType: async (id) => {
        const response = await baseGet({
            endpoint: `/v1/general/hotspot-types/${id}`,
        });
        return response.data;
    }
}

export default projectService;
